/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSearchPrivacySettingsRequest} from '@cash-web/protos/squareup/cash/customersearch/api/privacy/Privacy.pb'
import {GetSearchPrivacySettingsResponse} from '@cash-web/protos/squareup/cash/customersearch/api/privacy/Privacy.pb'


export const getPrivacySettings = (request: GetSearchPrivacySettingsRequest, options?: CashRequestOptions) => post<GetSearchPrivacySettingsRequest, GetSearchPrivacySettingsResponse>("/2.0/cash/get-privacy-settings", request, {...options, rejectOnError: true })